<template>
  <el-statistic
    :value-style="
      props.valueStyle +
      ';color:' +
      props.color +
      ';font-weight:' +
      (props.bold ? '600' : '500')
    "
    prefix="￥"
    :value="outputValue"
    :formatter="$priceFormat"
  >
    <template #prefix>
      <text
        style="font-size: 13px; margin-right: -6px"
        :style="{ color: props.color, fontWeight: props.bold ? '600' : '500' }"
      >
        ￥
      </text>
    </template>
  </el-statistic>
</template>

<script>
import { onMounted, reactive, ref, watch } from "vue";
import { useTransition } from "@vueuse/core";
import { Decimal } from "decimal.js";
export default {
  props: {
    value: Number,
    valueStyle: String,
    duration: {
      type: Number,
      default: 500,
    },
    color: {
      type: String,
      default: "#ffa500",
    },
    bold: Boolean,
  },
  setup(props) {
    const source = ref(0);
    const state = reactive({});
    let outputValue = useTransition(source, {
      duration: props.duration,
    });
    onMounted(() => {
      if (props.value) source.value = new Decimal(props.value).toNumber();
    });

    watch(
      () => props.value,
      (value) => {
        source.value = new Decimal(value).toNumber();
      },
    );

    return { state, props, outputValue };
  },
};
</script>
<style scoped></style>
